import { useEffect, useRef } from "react";
import { UsersViewModel } from "../../../viewmodels/setup/users/UsersViewModel";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";

import { withRouter } from "../../../shared/utility";

import { QuickbooksLoginViewModel } from "../../../viewmodels/quickbooks/QuickBooksLoginViewModel";

function QuickbooksLogin(props) {
  const { logout } = props;
  const {
    emptyModal,
    setEmptyModelOpen,
    onLoginPress,
  } = QuickbooksLoginViewModel(logout);

  const handleLogin = async () => {
    const redirectUrl = await onLoginPress();
    console.log("redirectUrl", redirectUrl);
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  };

  return (
    <div>
      <div className="mt-2">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center px-4 py-5 sm:px-4 card-custom">
            <div className="sm:flex-auto">
              <h1 className="text-base font-semibold leading-6 text-gray-900">
                Quickbooks
              </h1>
              <button
                type="button"
                onClick={handleLogin}
                className="w-full max-w-xl mt-4 inline-flex items-center justify-center rounded-lg bg-emerald-600 px-6 py-3 text-lg font-semibold text-white hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500"
                aria-label="Login to Quickbooks"
              >
                Login to Quickbooks
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(QuickbooksLogin)
);
